import React from 'react'
import leftBtn from '@/assets/images/leftbtn.png'
import './index.scss'
const Header = (props) => {
  let { tit,handleGoBackHeader } = props;

  return (
    <header className="common-header">
      <em onClick={handleGoBackHeader}><img src={leftBtn} alt="" /></em>
      <span>{tit}</span>
      { props.children}
    </header>
  )
}
export default Header
